import { blinkConstants } from '@thoughtspot/blink-constants';
import {
    FEATURE_FLAG_NAMES,
    isFeatureEnabled,
} from '@thoughtspot/feature-service';
import {
    isCopilotEnabled,
    isSpotterExperienceEnabled,
} from '@thoughtspot/session-service';

export const getSpotterPlanType = () => {
    if (isCopilotEnabled()) {
        return blinkConstants.spotterPlanTypes.standaloneSpotter;
    }
    if (isSpotterExperienceEnabled()) {
        return blinkConstants.spotterPlanTypes.tsaSpotter;
    }
    return blinkConstants.spotterPlanTypes.tsaSpotterDisabled;
};

export const getConvexStatus = () => {
    return isFeatureEnabled(
        FEATURE_FLAG_NAMES.ENABLE_CONVEX_EXPERIENCE,
    ) as boolean;
};
